import React from "react";
import Typical from "react-typical";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details" data-aos="zoom-in" data-aos-delay={200}>
          <div className="colz">
            <div className="cols-icon">
              <a href="https://web.facebook.com/?_rdc=1&_rdr">
                <i className="fa fa-facebook-square" />
              </a>
              <a href="#">
                <i className="fa fa-google-plus-square" />
              </a>
              <a href="https://www.instagram.com">
                <i className="fa fa-instagram" />
              </a>
              <a href="https://www.youtube.com/channel/UCb4ZDcIPonAzG9G2Lrw_Syg">
                <i className="fa fa-youtube-square" />
              </a>
              <a href="https://twitter.com">
                <i className="fa fa-twitter" />
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <div className="profile-role-tagline">
              Have a question? We have a answer
            </div>
            <span className="primary-text" style={{marginTop:"10px"}}>
              {" "}
              Hello, I'M <span className="highlighted-text">Acharya Arun Pandey</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Astrologer",
                    1000,
                    "Vastu Expert",
                    1000
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Know your Destiny  
            </span>
            <h4>
              Get Personal Horoscope
            </h4>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background" data-aos="zoom-in" data-aos-delay={200}></div>
        </div>
      </div>
    </div>
  );
}
